
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5613_21975)"}},[_c('path',{attrs:{"d":"M12.4997 5.83333C12.4997 5.61232 12.5875 5.40036 12.7438 5.24408C12.9 5.0878 13.112 5 13.333 5C13.554 5 13.766 5.0878 13.9223 5.24408C14.0785 5.40036 14.1663 5.61232 14.1663 5.83333V14.1667C14.1663 14.3877 14.0785 14.5996 13.9223 14.7559C13.766 14.9122 13.554 15 13.333 15C13.112 15 12.9 14.9122 12.7438 14.7559C12.5875 14.5996 12.4997 14.3877 12.4997 14.1667V5.83333ZM5.83301 5.83333C5.83301 5.61232 5.92081 5.40036 6.07709 5.24408C6.23337 5.0878 6.44533 5 6.66634 5C6.88735 5 7.09932 5.0878 7.2556 5.24408C7.41188 5.40036 7.49967 5.61232 7.49967 5.83333V14.1667C7.49967 14.3877 7.41188 14.5996 7.2556 14.7559C7.09932 14.9122 6.88735 15 6.66634 15C6.44533 15 6.23337 14.9122 6.07709 14.7559C5.92081 14.5996 5.83301 14.3877 5.83301 14.1667V5.83333Z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5613_21975"}},[_c('rect',{attrs:{"width":"20","height":"20","fill":"currentColor"}})])])])
          )
        }
      }
    